<template>
  <div>
    <!--begin::map-->
    <div class="row">
      <div class="col-md-3 col-12 mb-md-0 mb-8 pr-lg-0 pr-4">
        <div
          class="card card-custom h-100 shadow zindex-1 rounded-right-0"
          style="max-height: 80vh"
        >
          <div class="card-header border-0">
            <v-tabs v-model="currentTab">
              <v-tab>
                Adress-Filter
                <v-badge v-show="filterActive" dot inline color="bg-info" />
              </v-tab>
              <v-tab v-if="can('ROLE_DSN_READ_TOOL')">
                Karten-Tools
                <v-badge v-show="mapToolsActive" dot inline color="bg-info" />
              </v-tab>
            </v-tabs>
          </div>
          <div class="card-body py-0 overflow-auto">
            <v-tabs-items v-model="currentTab" reverse>
              <v-tab-item>
                <MapFilter
                  :map-views="mapViews"
                  @changeMapView="currentMapView = arguments[0]"
                  @refreshMap="setLoadingMapView(arguments[0])"
                  @change="filterActive = arguments[0]"
                  ref="filter"
                />
              </v-tab-item>
              <v-tab-item v-if="can('ROLE_DSN_READ_TOOL')">
                <map-tools
                  @refreshMap="mapToolChanged(arguments[0])"
                  @change="mapToolsActive = arguments[0]"
                  @emptyFilter="emptyFilter"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </div>
      <div class="col-md-9 col-12 pl-lg-0 pl-4">
        <GoogleMap
          :headers="dataTable.headers"
          @loadingMapView="setLoadingMapView(arguments[0])"
          ref="map"
        />
      </div>
    </div>
    <!--end::map-->

    <!-- begin::datatable -->
    <div class="row mt-10">
      <div class="col-12">
        <AddressDataTable
          v-if="can('ROLE_DSN_READ_TABLE')"
          :headers="dataTable.headers"
          item-key="address.id"
          class="elevation-1"
        />
      </div>
    </div>
    <!-- end::datatable -->

    <!-- begin::loadingMapView -->
    <b-modal
      id="loading-map-view-modal"
      cancel-disabled
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @shown="refreshMap"
    >
      <div class="text-center">
        <v-progress-linear value="15"></v-progress-linear>
        <span>
          Bitte warten.<br />
          Die Karte wird aktualisiert.
        </span>
      </div>
    </b-modal>
    <!-- end::loadingMapView -->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import GoogleMap from "@/view/content/maps/GoogleMap";

import MapFilter from "@/view/pages/addresses/filter/MapFilter";
import AddressDataTable from "@/view/pages/addresses/datatable/AddressDataTable";
import MapTools from "./addresses/filter/MapTools";

export default {
  name: "addresses",
  components: {
    MapTools,
    AddressDataTable,
    MapFilter,
    GoogleMap
  },
  data() {
    return {
      currentTab: null,
      currentMapView: "marker",
      mapViews: [
        { text: "Marker", value: "marker" },
        {
          text: "Heatmap (bald verfügbar)",
          value: "heatmap",
          disabled: true
        }
      ],
      status: [],
      selectedStatus: [],
      selectedAddresses: [],
      locationsCount: 0,
      loadingMapView: false,
      filterActive: false,
      mapToolsActive: false
    };
  },
  computed: {
    mapMarker() {
      return this.selectedAddresses.length > 0
        ? this.selectedAddresses
        : this.locations;
    },
    mapStatus() {
      let mapStatus = {};

      for (let i = 0; i < this.status.length; i++) {
        mapStatus[this.status[i].value] = this.status[i];
      }

      return mapStatus;
    },
    dataTable() {
      let headers = [
        {
          text: "Straße",
          align: "left",
          value: "address.street"
        },
        { text: "Hausnr.", value: "address.houseNumber" },
        { text: "Hausnr.-Zusatz", value: "address.houseNumberSuffix" },
        { text: "PLZ", value: "address.zipCode" },
        { text: "Anz. WE", value: "info.amountOfDwellingUnits" },
        { text: "Anz. GE", value: "info.amountOfBusinessUnits" },
        { text: "Verantwortlicher", value: "address.personId" },
        { text: "Wohnungswirtsch.", value: "address.housingIndustry" }
      ];

      const statusGroups = this.$store.getters.statusGroups;
      for (const statusGroup of statusGroups) {
        headers.push({
          text: statusGroup.text,
          value: "status." + statusGroup.value.key
        });
        if (statusGroup.value.key === "offer") {
          headers.push({
            text: "Vertriebsstatus WE",
            value: "status.offerWE",
          });
        }
      }

      return {
        headers,
        items: this.locations,
        selectedAddresses: []
      };
    }
  },
  methods: {
    loadStatus() {
      this.$store.dispatch("updateStatus");
    },
    loadSalesPersons() {
      this.$store.dispatch("updateSalesPersons");
    },
    async loadAddresses() {
      await this.$store.dispatch("updateAddresses", true);
    },
    setLoadingMapView(loadingMapView) {
      this.loadingMapView = loadingMapView;

      if (loadingMapView) {
        this.$bvModal.show("loading-map-view-modal");
      } else {
        this.$bvModal.hide("loading-map-view-modal");
      }
    },
    mapToolChanged(loadingMapView) {
      this.applyFilter();
      this.setLoadingMapView(loadingMapView);
    },
    refreshMap() {
      this.$refs.map.refreshMap();
    },
    applyFilter() {
      this.$refs.filter.saveFilter();
    },
    emptyFilter() {
      this.$refs.filter.emptyFilter();
    }
  },
  async beforeCreate() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "codeWerke", subTitle: "Vertriebssteuerungstool" }
    ]);

    this.loadStatus();
    this.loadSalesPersons();

    this.$root.$on("set-loading-map-view", this.setLoadingMapView);
  },
  async beforeDestroy() {
    await this.$store.dispatch("clearVisibleAddresses");
  }
};
</script>
